import { NumberInput, minValue } from "react-admin";
import { integerValidator } from "utils/validations";
import { DisciplineInput, GridItem, HoursInput } from "./Partials";

const CyclicDisciplineFields = () => (
  <>
    <DisciplineInput label="Цикъл" />

    <HoursInput
      source="totalHours"
      label="Общо часове"
      md={4}
      isRequired
    />
    <HoursInput
      source="totalLectures"
      label="Общо лекции"
      md={4}
      isRequired
    />
    <HoursInput
      source="totalLabs"
      label="Общо упражнения"
      md={4}
      isRequired
    />
    <GridItem md={6}>
      <NumberInput
        source="durationDays"
        label="Продължителност в учебни дни"
        fullWidth
        min={0}
        step={1}
        validate={[minValue(0, "Минималната стойност е 0."), integerValidator]}
        onWheel={e => e.target.blur()}
      />
    </GridItem>
    <HoursInput
      source="extracurricularActivities"
      label="Извънаудиторна заетост"
      md={6}
    />
  </>
);

export default CyclicDisciplineFields;
